package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.DieType
import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.model.GameEvent
import fr.manyverse.app.domain.repository.GameEventRepository

class CreateDiceRollEventUseCase(
    private val gameEventRepository: GameEventRepository
) {
    suspend operator fun invoke(
        tableId: String,
        triggeredBy: String,
        characterName: String,
        dieType: DieType,
        count: Int,
        results: List<Int>,
        isGmRoll: Boolean = false,
        modifier: Int = 0
    ): Result<GameEvent> {
        return gameEventRepository.createEvent(
            tableId = tableId,
            type = EventType.DICE_ROLLED,
            triggeredBy = triggeredBy,
            targetParticipants = emptyList(),
            content = EventContent.DiceRolled(
                characterName = characterName,
                dieType = dieType.name,
                count = count,
                results = results,
                isGmRoll = isGmRoll,
                modifier = modifier
            )
        )
    }
}
